import * as React from 'react';

import { createIcon } from '../Icon';
export const CornerLeftDownIcon = createIcon(
  <React.Fragment>
    <polyline points="14 15 9 20 4 15" />
    <path d="M20 4h-7a4 4 0 0 0-4 4v12" />
  </React.Fragment>,
  'CornerLeftDownIcon'
);
